<template>
  <rabbey-base-drawer
    :title="title"
    size="85%"
    :drawer.sync="drawer"
    :before-close="handleClose"
  >
    <el-row>
      <el-col>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="5">
              <el-col :span="5">
                <span>{{ headerSellerName }}:</span>
              </el-col>
              <el-col :span="12">
                <el-avatar
                  size="small"
                  :src="sellerPhoto"
                  style="margin-right: 10px"
                ></el-avatar>
                <span class="black-text font-weight-800">{{ sellerName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="5">
                <span>Mes:</span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  monthName !== "" ? $t(`months.${monthName}`) : ""
                }}</span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-col :span="7">
                <span>Cantidad:</span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  this.items.length
                }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="7">
                <span>Suma de montos:</span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{ mount }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-table3
          ref="table"
          :loading="loading"
          :data="items"
          :columns="columnsToShow"
          :actions="actions"
          @rtable-push-action="onPushAction"
        >
        </rabbey-table3>
      </el-col>
    </el-row>

    <DealsFormDrawer
      ref="form_view"
      :title="dealDetailTitle"
      :drawer.sync="dealDetailDrawer"
      :loading="true"
      :append-to-body="true"
      v-bind="dealDetailBind"
      @close-drawer="CloseDetailDrawer"
      @refresh-table="handleTableUpdate"
    />
  </rabbey-base-drawer>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import DatetimeFormatterColor from "@/components/functionals/DatetimeFormatterColor.vue";
import DealsFormDrawer from "@/components/deals/DealsFormDrawer.vue";
import { formatterMoney, getPaginatedItems } from "@/utils";
import RabbeyBaseDrawer from "@/components/RabbeyBaseDrawer.vue";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import Deal from "@/models/deals/Deal";

export default {
  components: { RabbeyBaseDrawer, DealsFormDrawer },
  name: "DealReportDetail",
  props: {
    whatsThisReportFor: {
      type: String,
      default: "deals" // agent
    }
  },
  data() {
    let self = this;
    return {
      title: `Listado de Oportunidades Mes: ${this.monthName}`,
      dealDetailTitle: "",
      dealDetailDrawer: false,
      dealDetailBind: {
        initModel: Deal
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      monthName: "",
      qty: 0,
      mount: 0,
      sellerPhoto: "",
      sellerName: "",
      detailProps: {},
      drawer: false,
      loading: false,
      isAgent: false,
      items: [],
      model: {},
      rules: {},
      Year: new Date().getFullYear(),
      Month: 0,
      DepartmentId: 32,
      IdEmployee: 0,
      agendas: [
        {
          prop: "AppoimentId",
          label: "Numero",
          minWidth: 100
          // fixed: true
        },
        {
          prop: "AppoimentTitle",
          label: "Titulo",
          minWidth: 250
          // fixed: true
        },
        {
          prop: "Description",
          label: "Descripcion",
          minWidth: 250
          // fixed: true
        },
        {
          prop: "ProspectName",
          label: "Prospecto",
          minWidth: 250
          // fixed: true
        },
        {
          prop: "StarDate",
          label: "Fecha inicio",
          minWidth: 150,
          formatter: DatetimeFormatter,
          sortable: true
          // fixed: true
        },
        {
          prop: "EndDate",
          label: "Fecha fin",
          minWidth: 150,
          formatter: DatetimeFormatter,
          sortable: true
          // fixed: true
        },
        {
          prop: "Amount",
          label: "Monto",
          minWidth: 100
          // formatter: InteractionTypeTagFormatter
          // fixed: true
        },

        {
          prop: "SellerName",
          label: "Vendedor",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SellerImage"
          }
        }
      ],
      columns: [
        {
          prop: "DealsId",
          label: "NO",
          width: 70,
          align: "center",
          fixed: true
        },
        {
          prop: "DealDescription",
          label: "Descripción de Oportunidad",
          minWidth: 225
        },
        {
          prop: "Quantity",
          label: "Cantidad",
          width: 110
        },
        {
          prop: "UnitPrice",
          label: "P. Unitario",
          width: 110
          // formatter: row => formatterMoney(row.UnitPrice)
        },
        {
          prop: "TotalAmount",
          label: "Monto total",
          width: 100
          // formatter: row => formatterMoney(row.Amount)
        },
        // {
        //   prop: "Currency.Name",
        //   label: "Moneda",
        //   width: 100
        //   // formatter: row => (row.Currency ? row.Currency.Name : "")
        // },
        {
          label: "Contacto",
          prop: "ContactName",
          minWidth: 200
        },
        {
          prop: "InitialDate",
          label: "Fecha de propuesta",
          formatter: DatetimeFormatter,
          width: 180
        },
        {
          prop: "FinalDate",
          label: "Fecha de cierre",
          formatter: DatetimeFormatterColor,
          width: 180
        },
        {
          prop: "SalesPersonName",
          label: "Vendedor",
          minWidth: 200,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SalesPersonPhoto"
          }
        },
        {
          prop: "SupportSellerName",
          label: "Soporte de venta",
          width: 250,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SupportSellerPhoto"
          }
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit",
          condition: () =>
            self.IsInRoles([
              self.roles.Admin,
              self.roles.SuperUsuario,
              self.roles.CEO,
              self.roles.SupervisorDeVentas,
              self.roles.SupervisorDeSoporteDeVentas
            ])
        }
      ],
      mountFormatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      })
    };
  },
  created() {
    // this.getItems();
  },
  computed: {
    headerSellerName() {
      if (this.isAgent) {
        return "Agente";
      }
      return "Vendedor";
    },
    dateFilter() {
      if (this.detailProps.close) {
        return 3;
      } else if (!this.detailProps.close) {
        return 2;
      } else {
        return 1;
      }
    },
    columnsToShow() {
      return this.whatsThisReportFor === "agenda" ? this.agendas : this.columns;
    }
  },
  methods: {
    formatterMoney,
    getPaginatedItems,
    async show(props, agent = false) {
      this.Year = props.Year;
      this.Month = props.Month;
      this.DepartmentId = 32;
      this.IdEmployee = props.row.IdEmployee;
      this.items = [];

      if (agent) {
        this.title = "Detalle de Oportunidades por Agente";
        this.isAgent = true;
      } else {
        this.title = "Detalle de Oportunidades por Vendedor";
        this.isAgent = false;
      }

      this.drawer = true;
      this.monthName = props.column;
      this.sellerPhoto = props.row.SalesPersonPhoto;
      this.sellerName = props.row.SalesPersonName;
      this.qty = this.items.length;
      this.detailProps = props;

      this.whatsThisReportFor === "agenda"
        ? await this.getAgendas()
        : await this.getItems();
      // await this.getItems();
      // await this.getAgendas();
    },
    async getAgendas() {
      await this.$http
        .get("/api/Calendar/GetAllAgendaDetails", {
          params: {
            Year: this.Year,
            Month: this.Month,
            DepartmentId: this.DepartmentId,
            IdEmployee: this.IdEmployee
          }
        })
        .then(({ data }) => {
          this.items = data;
        })
        .catch((err) => {
          console.error("Error fetching agenda details:", err);
        });
    },
    async getItems() {
      this.loading = true;
      await this.$http
        .get("/api/deals/DealReportByPhase", {
          params: {
            companyID: this.currentCompany,
            Year: this.detailProps.year,
            DealsMonth: this.detailProps.month,
            SellerId: this.detailProps.row.SalesPersonId,
            PhaseID: this.detailProps.PhaseID,
            DateFilter: this.dateFilter,
            UserID: this.detailProps.row.SellerId,
            Close: this.detailProps.close,
            limit: 9999,
            Page: 1,
            //BySeller: this.detailProps.BySeller,
            //SellerId: this.detailProps.row.SellerId,
            SupportSellerId: this.detailProps.row.AgentId,
            AgentId: this.detailProps.row.AgentId
          }
        })
        .then(({ data }) => {
          const { Items, CurrentPage, ItemCount } = data;
          let mountSum = 0;
          data.Items.forEach((i) => (mountSum += i.TotalAmount));
          this.mount = this.mountFormatter.format(mountSum);
          this.items = Items;
          this.pagination.total = ItemCount;
          this.pagination.currentPage = CurrentPage;

          setTimeout(() => (this.loading = false), 100);
        });
    },
    handleClose(done) {
      this.items = [];
      this.mount = 0;
      this.loading = false;
      done();
    },
    async onPushAction(c) {
      var { data } = await this.$http.get("/api/deals/GetByID/", {
        timeout: 3 * 60 * 1000,
        params: {
          DealsId: c.row.DealsId
        }
      });

      const isClient = data.CustomerCode
        ? data.CustomerCode.startsWith("CL")
        : false;
      const isProspect = data.CustomerCode
        ? data.CustomerCode.startsWith("C0")
        : false;
      const code = data.CustomerCode ?? "";

      switch (c.command) {
        case "view": {
          this.dealDetailTitle = `Detalle de Oportunidad # ${c.row.DealsId}`;
          this.dealDetailBind.isClient = isClient;
          this.dealDetailBind.isProspect = isProspect;
          this.dealDetailBind.code = code;
          this.dealDetailBind.initModel = JSON.parse(JSON.stringify(c.row));
          this.dealDetailBind.initModel = {
            ...data
          };
          this.dealDetailBind.isEdit = false;
          this.dealDetailBind.isView = true;
          this.dealDetailDrawer = true;
          break;
        }

        case "edit": {
          this.dealDetailTitle = `Detalle de Oportunidad # ${c.row.DealsId}`;
          this.dealDetailBind.isClient = isClient;
          this.dealDetailBind.isProspect = isProspect;
          this.dealDetailBind.code = code;
          this.dealDetailBind.initModel = {
            ...data
          };
          this.dealDetailBind.isView = false;
          this.dealDetailBind.isEdit = true;
          this.dealDetailDrawer = true;
          break;
        }

        default:
          break;
      }
    },
    CloseDetailDrawer() {
      this.dealDetailDrawer = false;
    },
    async handleTableUpdate() {
      this.whatsThisReportFor === "agenda"
        ? await this.getAgendas()
        : await this.getItems();
      this.$emit("getUpdatedData");
    }
  }
};
</script>

<style></style>
